export const description =
  "FranceAgriMer : aides nationales pilotées par filière (serres décarbonées, méthanisation, fruits-légumes, viticulture). Appels à projets thématiques cumulables CEE + PCAE.";
